import React, { useState } from "react";
import Avatar from "../../../../components/Avatar/Avatar";
import style from "./Activity.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../assets/svg/icons/common/CaretRight";
import DOMPurify from "dompurify";

function ActivityRow({ activity }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${style.activity_row} ${open ? style.expanded : ""} `}>
      <ButtonIcon
        onClick={() => setOpen(!open)}
        size="small"
      >
        <CaretRight />
      </ButtonIcon>

      <div className={style.activity_row_content}>
        <Avatar />
        <div className={style.message}>
          <div>
            <span>{activity.who}</span>
            {/* <span>Approved application</span> */}
          </div>
          {open && (
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(activity.content),
              }}
            ></p>
          )}
        </div>
      </div>

      {/* <span className={style.activity_row_time} >{moment(activity.created_at).format("MMM D, YYYY | H:mm A")}</span> */}
      <span className={style.activity_row_time}>{activity.created_ago}</span>
    </div>
  );
}

export default ActivityRow;
